import { reportConstants } from '../constants/report.constants';
import reportService from '../services/report.service';
import { alertActions } from './alert.actions';
import { b64toBlob } from '../helpers/base64';

export const reportActions = {
  fetchWorkJourney,
  fetchIntegrationLog,
  fetchRequestsPerManager,
  fetchNotifications,
  fetchLastContact,
  fetchActivityIntervals,
  fetchActivitySummary,
  fetchActivityDashboard,
  fetchAppActivitySummary,
  fetchAccess,
  fetchMailLog,
  downloadMailLogAttachment,
  createNotification,
  migrateActivityIntervals,
  reprocessJourneyIntervals,
  fetchLicenseUsageCurrent,
  fetchLicenseUsageHistory,
  fetchLicenseUsageFile,
  fetchApprovedRequests,
  fetchSessionsReport,
  fetchAccessOutsideJourney,
  fetchLastContactPdf,
};

function fetchActivitySummary(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const summary = await reportService.fetchActivitySummary(params);
      if (params.export && summary.file) {
        const blob = b64toBlob(summary.file, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'resumo-sessoes.xlsx');
        tempLink.click();
      } else {
        dispatch(success(summary));
      }
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.ACTIVITY_SUMMARY_REQUEST } }
  function success(activitySummary) { return { type: reportConstants.ACTIVITY_SUMMARY_SUCCESS, activitySummary } }
  function failure(error) { return { type: reportConstants.ACTIVITY_SUMMARY_FAILURE, error } }
}

function fetchAppActivitySummary(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const summary = await reportService.fetchAppActivitySummary(params);
      if (params.export && summary.file) {
        const blob = b64toBlob(summary.file, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'atividade-aplicativos-resumo.xlsx');
        tempLink.click();
      } else {
        dispatch(success(summary));
      }
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.APP_ACTIVITY_SUMMARY_REQUEST } }
  function success(appActivitySummary) { return { type: reportConstants.APP_ACTIVITY_SUMMARY_SUCCESS, appActivitySummary } }
  function failure(error) { return { type: reportConstants.APP_ACTIVITY_SUMMARY_FAILURE, error } }
}

function fetchActivityDashboard(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const dashboard = await reportService.fetchActivityDashboard(params);
      dispatch(success(dashboard));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.ACTIVITY_DASHBOARD_REQUEST } }
  function success(activityDashboard) { return { type: reportConstants.ACTIVITY_DASHBOARD_SUCCESS, activityDashboard } }
  function failure(error) { return { type: reportConstants.ACTIVITY_DASHBOARD_FAILURE, error } }
}

function fetchWorkJourney(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const workJourneyRegisters = await reportService.fetchWorkJourney(params);    
      if (params.export && workJourneyRegisters.file) {        
        const blob = b64toBlob(workJourneyRegisters.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'historico-jornada.xlsx');
        tempLink.click();        
      } else {
        dispatch(success(workJourneyRegisters));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.WORKJOURNEY_FETCH_REQUEST } }
  function success(workJourneyRegisters) { return { type: reportConstants.WORKJOURNEY_FETCH_SUCCESS, workJourneyRegisters } }
  function failure(error) { return { type: reportConstants.WORKJOURNEY_FETCH_FAILURE, error } }
}

function fetchActivityIntervals(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const activityIntervals = await reportService.fetchActivityIntervals(params);    
      if (params.export && activityIntervals.file) {        
        const blob = b64toBlob(activityIntervals.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'sessoes-bloqueios.xlsx');
        tempLink.click();        
      } else {
        dispatch(success(activityIntervals));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.ACTIVITY_INTERVAL_REQUEST } }
  function success(activityIntervalRegisters) { return { type: reportConstants.ACTIVITY_INTERVAL_SUCCESS, activityIntervalRegisters } }
  function failure(error) { return { type: reportConstants.ACTIVITY_INTERVAL_FAILURE, error } }
}

function fetchIntegrationLog(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const integrationLogs = await reportService.fetchIntegrationLog(params);      
      dispatch(success(integrationLogs));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.INTEGRATIONLOG_FETCH_REQUEST } }
  function success(integrationLogs) { return { type: reportConstants.INTEGRATIONLOG_FETCH_SUCCESS, integrationLogs } }
  function failure(error) { return { type: reportConstants.INTEGRATIONLOG_FETCH_FAILURE, error } }
}

function createNotification(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const notification = await reportService.createNotification(params);      
      dispatch(success(notification));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.NOTIFICATION_CREATE_REQUEST } }
  function success(integrationLogs) { return { type: reportConstants.NOTIFICATION_CREATE_SUCCESS, integrationLogs } }
  function failure(error) { return { type: reportConstants.NOTIFICATION_CREATE_FAILURE, error } }
}

function migrateActivityIntervals() {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportService.migrateActivityIntervals();      
      dispatch(success(result));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.MIGRATE_ACTIVITY_INTERVAL_REQUEST } }
  function success(migrateActivityInterval) { return { type: reportConstants.MIGRATE_ACTIVITY_INTERVAL_SUCCESS, migrateActivityInterval } }
  function failure(error) { return { type: reportConstants.MIGRATE_ACTIVITY_INTERVAL_FAILURE, error } }
}

function reprocessJourneyIntervals() {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportService.reprocessJourneyIntervals();
      dispatch(success(result));
      dispatch(alertActions.success('Bloqueios fora da jornada reclassificados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.REPROCESS_JOURNEY_REQUEST } }
  function success(reprocessJourney) { return { type: reportConstants.REPROCESS_JOURNEY_SUCCESS, reprocessJourney } }
  function failure(error) { return { type: reportConstants.REPROCESS_JOURNEY_FAILURE, error } }
}

function fetchRequestsPerManager(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const integrationLogs = await reportService.fetchRequestsPerManager(params);      
      dispatch(success(integrationLogs));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.INTEGRATIONLOG_FETCH_REQUEST } }
  function success(integrationLogs) { return { type: reportConstants.INTEGRATIONLOG_FETCH_SUCCESS, integrationLogs } }
  function failure(error) { return { type: reportConstants.INTEGRATIONLOG_FETCH_FAILURE, error } }
}

function fetchNotifications(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const notifications = await reportService.fetchNotifications(params);      
      dispatch(success(notifications));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.NOTIFICATION_FETCH_REQUEST } }
  function success(notifications) { return { type: reportConstants.NOTIFICATION_FETCH_SUCCESS, notifications } }
  function failure(error) { return { type: reportConstants.NOTIFICATION_FETCH_FAILURE, error } }
}

function fetchLastContact(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const lastContactRegisters = await reportService.fetchLastContact(params);    
      if (params.export && lastContactRegisters.file) {        
        const blob = b64toBlob(lastContactRegisters.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'ultimo-contato.xlsx');
        tempLink.click();        
      } else {
        dispatch(success(lastContactRegisters));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.LASTCONTACT_FETCH_REQUEST } }
  function success(lastContactRegisters) { return { type: reportConstants.LASTCONTACT_FETCH_SUCCESS, lastContactRegisters } }
  function failure(error) { return { type: reportConstants.LASTCONTACT_FETCH_FAILURE, error } }
}

function fetchAccess(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const accessRegisters = await reportService.fetchAccess(params);    
      if (params.export && accessRegisters.file) {        
        const blob = b64toBlob(accessRegisters.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'acesso.xlsx');
        tempLink.click();        
      } else {
        dispatch(success(accessRegisters));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.ACCESS_FETCH_REQUEST } }
  function success(accessRegisters) { return { type: reportConstants.ACCESS_FETCH_SUCCESS, accessRegisters } }
  function failure(error) { return { type: reportConstants.ACCESS_FETCH_FAILURE, error } }
}

function fetchMailLog(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const mailLogs = await reportService.fetchMailLog(params);
      if (params.export && mailLogs.file) {
        const blob = b64toBlob(mailLogs.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'emails.xlsx');
        tempLink.click();
      } else {
        dispatch(success(mailLogs));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.MAILLOG_FETCH_REQUEST } }
  function success(mailLogs) { return { type: reportConstants.MAILLOG_FETCH_SUCCESS, mailLogs } }
  function failure(error) { return { type: reportConstants.MAILLOG_FETCH_FAILURE, error } }
}

function downloadMailLogAttachment(attachment) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportService.fetchMailLogAttachment(attachment.Id);
      if (result.file) {
        const blob = b64toBlob(result.file, result.contentType || attachment.ContentType);
        var fileURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = fileURL;
        tempLink.setAttribute('download', result.fileName || attachment.FileName);
        tempLink.click();
      }
      dispatch(success());
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.MAILLOG_ATTACHMENT_DOWNLOAD_REQUEST } }
  function success() { return { type: reportConstants.MAILLOG_ATTACHMENT_DOWNLOAD_SUCCESS } }
  function failure(error) { return { type: reportConstants.MAILLOG_ATTACHMENT_DOWNLOAD_FAILURE, error } }
}

function fetchLicenseUsageCurrent() {
  return async dispatch => {
    dispatch(request());

    try {
      const licenseUsageCurrent = await reportService.fetchLicenseUsageCurrent();
      dispatch(success(licenseUsageCurrent));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.LICENSEUSAGE_CURRENT_REQUEST } }
  function success(licenseUsageCurrent) { return { type: reportConstants.LICENSEUSAGE_CURRENT_SUCCESS, licenseUsageCurrent } }
  function failure(error) { return { type: reportConstants.LICENSEUSAGE_CURRENT_FAILURE, error } }
}

function fetchLicenseUsageHistory(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const licenseUsageHistory = await reportService.fetchLicenseUsageHistory(params);
      dispatch(success(licenseUsageHistory));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.LICENSEUSAGE_HISTORY_REQUEST } }
  function success(licenseUsageHistory) { return { type: reportConstants.LICENSEUSAGE_HISTORY_SUCCESS, licenseUsageHistory } }
  function failure(error) { return { type: reportConstants.LICENSEUSAGE_HISTORY_FAILURE, error } }
}

function fetchLicenseUsageFile(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportService.fetchLicenseUsageFile(params);
      if (result.file) {
        const contentType = params.exportPdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const extension = params.exportPdf ? 'pdf' : 'xlsx';
        const blob = b64toBlob(result.file, { type: contentType });
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', `uso-licenca-${params.year}-${params.month}.${extension}`);
        tempLink.click();
      }
      dispatch(success());
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.LICENSEUSAGE_FILE_REQUEST } }
  function success() { return { type: reportConstants.LICENSEUSAGE_FILE_SUCCESS } }
  function failure(error) { return { type: reportConstants.LICENSEUSAGE_FILE_FAILURE, error } }
}

function fetchApprovedRequests(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportService.fetchApprovedRequests(params);
      if ((params.export || params.exportPdf) && result.file) {
        const contentType = params.exportPdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const extension = params.exportPdf ? 'pdf' : 'xlsx';
        const blob = b64toBlob(result.file, { type: contentType });
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', `solicitacoes-aprovadas.${extension}`);
        tempLink.click();
      } else {
        dispatch(success(result));
      }
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.APPROVEDREQUESTS_FETCH_REQUEST } }
  function success(approvedRequests) { return { type: reportConstants.APPROVEDREQUESTS_FETCH_SUCCESS, approvedRequests } }
  function failure(error) { return { type: reportConstants.APPROVEDREQUESTS_FETCH_FAILURE, error } }
}

function fetchSessionsReport(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportService.fetchSessionsReport(params);
      if ((params.export || params.exportPdf) && result.file) {
        const contentType = params.exportPdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const extension = params.exportPdf ? 'pdf' : 'xlsx';
        const blob = b64toBlob(result.file, { type: contentType });
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', `sessoes.${extension}`);
        tempLink.click();
      } else {
        dispatch(success(result));
      }
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.SESSIONS_FETCH_REQUEST } }
  function success(sessionsReport) { return { type: reportConstants.SESSIONS_FETCH_SUCCESS, sessionsReport } }
  function failure(error) { return { type: reportConstants.SESSIONS_FETCH_FAILURE, error } }
}

function fetchAccessOutsideJourney(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportService.fetchAccessOutsideJourney(params);
      if ((params.export || params.exportPdf) && result.file) {
        const contentType = params.exportPdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const extension = params.exportPdf ? 'pdf' : 'xlsx';
        const blob = b64toBlob(result.file, { type: contentType });
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', `acessos-fora-jornada.${extension}`);
        tempLink.click();
      } else {
        dispatch(success(result));
      }
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.OUTSIDEJOURNEY_FETCH_REQUEST } }
  function success(outsideJourney) { return { type: reportConstants.OUTSIDEJOURNEY_FETCH_SUCCESS, outsideJourney } }
  function failure(error) { return { type: reportConstants.OUTSIDEJOURNEY_FETCH_FAILURE, error } }
}

function fetchLastContactPdf(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportService.fetchUsersWithoutContactPdf(params);
      if (result.file) {
        const blob = b64toBlob(result.file, { type: 'application/pdf' });
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'usuarios-sem-contato.pdf');
        tempLink.click();
      }
      dispatch(success());
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.LASTCONTACT_PDF_REQUEST } }
  function success() { return { type: reportConstants.LASTCONTACT_PDF_SUCCESS } }
  function failure(error) { return { type: reportConstants.LASTCONTACT_PDF_FAILURE, error } }
}